import { EdgesGeometry, LineSegments, Object3D } from "three"
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils'
import Constants from "../lib/Constants"

export default class Layout
{
    constructor(_options)
    {
        this.database = _options.database
        this.resources = _options.resources
        this.materials = _options.materials

        this.container = new Object3D()
        this.container.name = 'layout_container'
    }

    static init(_options)
    {
        const layout = new Layout(_options)

        layout.instance = new Object3D()
        layout.instance.name = 'layout_instance'

        layout.wframeMesh = new Object3D()
        layout.wframeMesh.name = 'layout_wframe_instance'

        layout.resources.items.layout.scene.traverse((child) =>
        {
            if(child.isMesh) layout.instance.add(child.clone())
        })

        layout._setInstance()
        layout._setUtils()

        layout.container.add(layout.instance, layout.wframeMesh)

        return layout
    }

    async _setInstance()
    {
        const wframeGeoArray = []
        const toRemove = []

        for(let mesh of this.instance.children)
        {
            mesh.material = this._getMaterial(mesh.name)
            mesh.castShadow = true
            mesh.receiveShadow = true

            if(mesh.name === 'forest')
            {
                this.forest = mesh
                toRemove.push(mesh)
            }
            else if(mesh.name === 'building_base')
            {
                this.buildingBase = mesh
                toRemove.push(mesh)
            }
            else if(mesh.name === 'tree_base')
            {
                this.treeBase = mesh
                toRemove.push(mesh)
            }
            else if(mesh.name === 'map')
            {
                Constants.SCENE.minBoundary.copy(mesh.geometry.boundingBox.min)
                Constants.SCENE.maxBoundary.copy(mesh.geometry.boundingBox.max)
                mesh.castShadow = false
                this.map = mesh
            }
            else
            {
                if(mesh.name.includes("building_"))
                {
                    wframeGeoArray.push(mesh.geometry)
                }
            }
        }
        toRemove.forEach(x => this.instance.remove(x))
        this.instance.matrixAutoUpdate = false

        // Add Wireframes
        this.wframeGeo = new EdgesGeometry(mergeGeometries(wframeGeoArray))
        this.wframeMesh.add(new LineSegments(this.wframeGeo, this.materials.items.wireframeMat))
    }

    _setUtils()
    {
        this.grapesMeshes = this.instance.children.filter(x => this.database.grapes.find(y => y.meshElement === x.name))
    }

    _getMaterial(name)
    {
        if(name === 'map') return this.materials.items.terrainMat
        else if(name.includes('lake_')) return this.materials.items.lakeMat
        else if(name === 'bottle') return this.materials.items.treesMat
        else if(name.includes("building")) return this.materials.items.buildingMat

        else if(this.database.isWineEnabled(name)) return this.materials.items.lotMat
        else return this.materials.items.lotDisabledMat
    }

    getMeshes(itemId)
    {
        const meshNames = this.database.getMeshesFromId(itemId)
        const meshes = this.instance.children.filter(x => meshNames.includes(x.name))
        return meshes
    }

    getMesh(meshName)
    {
        return this.instance.children.find(x => x.name === meshName)
    }

    updateEnabledMaterials()
    {
        for(let g of this.grapesMeshes)
        {
            if(Constants.VARS.mode === 'w')
            {
                g.material = this.database.isWineEnabled(g.name) ? this.materials.items.lotMat : this.materials.items.lotDisabledMat
            }
            else
            {
                g.material = this.database.isGrapeEnabled(g.name) ? this.materials.items.lotMat : this.materials.items.lotDisabledMat
            }
        }
    }
}